var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__youtube-suggester"},[_c('a-button',{attrs:{"type":"link","href":"https://synthetic.ua/pages","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("app.knowledge_base"))+" ")])],1),(_vm.version)?_c('div',{staticClass:"footer__version"},[_vm._v(" "+_vm._s(_vm.version)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }